import {LngLat} from 'mapbox-gl';
import {isArray} from 'lodash';

export default function convertLngLat(input: mapboxgl.LngLatLike | number[]): mapboxgl.LngLat {
    if (isArray(input)) {
        return LngLat.convert([input[0], input[1]]);
    } else {
        return LngLat.convert(input);
    }
}
